/** Supported environment mode constants. Used to distinguish between Development, Test, and Production environments. */
export enum Environment {
  Development = 'Development',
  Test = 'Test',
  Production = 'Production'
}
